<section class="nav-list">
  <div class="nav-container">
    @switch (layoutContent) {
      @case ('menu') {
        <section class="layout-content" [class.slideOutAnimation-nav]="isMobileOrTablet && backToMenuSelected">
          @if (menuChecked) {
            <div>
              <div class="nav-header">
                @if (selectedTheme == 'light') {
                  <img src="images/icons/header-logo.svg" alt="Logo" />
                } @else {
                  <img src="images/icons/header-dark-logo.svg" alt="Logo" />
                }
              </div>
            </div>
            <div class="nav-content">
              @if (layoutContent === 'menu') {
                <mat-nav-list>
                  @for (item of menuItems; track item) {
                    <!-- @if (item.showMenu) { -->
                    <app-nav-item [menu]="item" [parentMenu]="null" [parentMenuIsOpen]="false"></app-nav-item>
                    <!-- } -->
                  }
                </mat-nav-list>
              }
            </div>
            <div class="nav-footer">
              @if (isMobileOrTablet) {
                <button type="button" class="menu-button" (click)="modeSwitch()">
                  <div class="title">
                    <span class="icon" [class.icon-sun]="selectedTheme === 'light'" [class.icon-moon-01]="selectedTheme !== 'light'"></span>
                    Mode
                  </div>
                  <label class="label">{{ selectedTheme == 'light' ? 'Light' : 'Dark' }} Mode</label>
                </button>
                <button type="button" class="menu-button" (click)="changeCurrency()">
                  <div class="title">
                    <span class="icon icon-currency-dollar-circle"></span>
                    Currency
                  </div>
                  <label class="label">
                    {{ selectedCurrency?.currencyName }}
                    {{ selectedCurrency?.symbol }}
                  </label>
                </button>
              }
              <button type="button" class="menu-button" (click)="logout()">
                <div class="title">
                  <span class="icon icon-log-out-01"></span>
                  Sign out
                </div>
              </button>
            </div>
          } @else {
            <app-loading />
          }
        </section>
      }
      @case ('theme') {
        <app-theme-side-menu-selector (mode)="toggleTheme($event)" [selectedTheme]="selectedTheme" (backToMenu)="backToMenu()" class="slideAnimation-nav" />
      }
      @case ('currency') {
        <app-currency-menu-selector (newSelect)="setNewCurrency($event)" (selectedCurrency)="(selectedCurrency)" (backToMenu)="backToMenu()" class="slideAnimation-nav" />
      }
    }
  </div>
  <div class="nav-close">
    <div class="icon-x-close" (click)="closeMenu()"></div>
  </div>
</section>
